/* eslint-disable default-param-last */
import {
  FETCH_NETWORK,
  FETCH_AFFILIATES,
  FETCH_AFFILIATE,
  CLEAR_AFFILIATE,
  SAVE_TAGS,
  FETCH_CHECK,
  SELECT_AFFILIATE,
  SAVE_AFFILIATES,
  SELECT_AFFILIATE_DATA,
  SEARCH_AFFILIATE,
  FETCH_SEARCH_AFFILIATES,
  CATEGORIES_AFFILIATES,
  CLEAR_AFFILIATES,
} from '../types'

export function affiliates(state = [], action) {
  switch (action.type) {
    case FETCH_AFFILIATES:
      return action.data
    default:
      return state
  }
}

export function affiliatesTotal(state = 0, action) {
  switch (action.type) {
    case FETCH_AFFILIATES:
      return state === 0 ? action.data?.total : state
    case CLEAR_AFFILIATES:
      return 0
    default:
      return state
  }
}

export function check(state = [], action) {
  switch (action.type) {
    case FETCH_CHECK:
      return action.data
    default:
      return state
  }
}
export function affiliate(state = {}, action) {
  switch (action.type) {
    case FETCH_AFFILIATE:
      return action.data
    case SAVE_TAGS:
      state.tags = action.arr
      return { ...state }
    case CLEAR_AFFILIATE:
      return {}
    default:
      return state
  }
}

export function network(state = {}, action) {
  switch (action.type) {
    case FETCH_NETWORK:
      return action.data
    default:
      return state
  }
}

export const selectAffiliate = (state = '', action) => {
  switch (action.type) {
    case SELECT_AFFILIATE:
      return action.data
    default:
      return state
  }
}

export const saveAffilliates = (state = [], action) => {
  switch (action.type) {
    case SAVE_AFFILIATES:
      return action.data
    default:
      return state
  }
}

export function selectAffiliateData(state = {}, action) {
  switch (action.type) {
    case SELECT_AFFILIATE_DATA:
      return action.data
    default:
      return state
  }
}

export function searchAffiliate(state = '', action) {
  switch (action.type) {
    case SEARCH_AFFILIATE:
      return action.value
    default:
      return state
  }
}

export function affiliatesSearch(state = [], action) {
  switch (action.type) {
    case FETCH_SEARCH_AFFILIATES:
      return action.data
    default:
      return state
  }
}

export function categoriesAffiliates(state = [], action) {
  switch (action.type) {
    case CATEGORIES_AFFILIATES:
      return action.data
    default:
      return state
  }
}
